// extracted by mini-css-extract-plugin
export default {"container":"WSCopyText-module_container-YShPO","body":"WSCopyText-module_body-TzH2i","text":"WSCopyText-module_text-bFtMW","copyBtn":"WSCopyText-module_copyBtn-pqG10"};